// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ExternalNetworkScanStatusSchema = z.enum(['IDLE','DISCOVERING','SCANNING','ANALYZING','DIFFING','COMPLETED','FAILED','STOPPED'] as const);

export type ExternalNetworkScanStatusType = `${z.infer<typeof ExternalNetworkScanStatusSchema>}`

export default ExternalNetworkScanStatusSchema;
